import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import { Toaster } from "sonner";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import Admin from "@/pages/Admin";
import Home from "@/pages/Home";
import Clients from "@/pages/Clients";
import Talent from "@/pages/Talent";
import HowWeWork from "@/pages/HowWeWork";
import About from "@/pages/About";
import Contact from "@/pages/Contact";

const useLenis = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.__lenis = null; };
  }, []);
};

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useLenis();
  return (
    <BrowserRouter>
      <ScrollTop />
      <Nav />
      <main data-testid="site-main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/talent" element={<Talent />} />
          <Route path="/how-we-work" element={<HowWeWork />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
      <Toaster position="bottom-left" toastOptions={{ style: { background: "#0E0E10", color: "#F1ECE2", border: "1px solid #FF4D1A", borderRadius: 4 } }} />
    </BrowserRouter>
  );
}

export default App;
